import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'
import { parseRequestError } from '../utilities'
import AppAlertComponent from './AppAlertComponent'
import LoadingCard from './LoadingCard'

interface Props<TData> {
  query: UseQueryResult<TData, Error>
  children: (data: TData) => React.ReactNode
  customLoadingUI?: React.ReactNode
  customErrorUI?: React.ReactNode
  showLoadingOnlyOnFirstFetch?: boolean // New prop
}

function PageLoader<TData>(props: Props<TData>) {
  const {
    query,
    children,
    customLoadingUI,
    customErrorUI,
    showLoadingOnlyOnFirstFetch = false,
  } = props

  // Only show loading state if it's the initial load or if showLoadingOnlyOnFirstFetch is false
  if (
    query.isLoading &&
    (!showLoadingOnlyOnFirstFetch || query.isInitialLoading)
  ) {
    return customLoadingUI ? (
      <>{customLoadingUI}</>
    ) : (
      <LoadingCard title="Loading" />
    )
  }

  // Only show error state if it's the initial error or if showLoadingOnlyOnFirstFetch is false
  if (
    query.isError &&
    (!showLoadingOnlyOnFirstFetch || query.isInitialLoading)
  ) {
    return customErrorUI ? (
      <>{customErrorUI}</>
    ) : (
      <div className="max-w-xl mx-auto">
        <AppAlertComponent
          children={null}
          variant="error"
          title="Error"
          text={parseRequestError(query.error).message}
        ></AppAlertComponent>
      </div>
    )
  }

  // For subsequent fetches, if data exists, use it even during loading/error states
  return children(query.data as TData)
}

export default PageLoader
